import { dropBoolean } from 'utils/drops';

const getLocalEstoqueFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'local', label: 'Local' },
  { name: 'descricao', label: 'Descrição', initial: true },
  {
    name: 'filial',
    label: 'Filial',
    type: 'select',
    options: drops?.Filial,
    multiple: true,
  },
  {
    name: 'disponibilizar',
    label: 'Disponibilizar',
    type: 'select',
    options: dropBoolean,
  },
  { name: 'negativo', label: 'Negativo', type: 'select', options: dropBoolean },
  { name: 'ativo', label: 'Ativo', type: 'select', options: dropBoolean },
];

export default getLocalEstoqueFilterFields;
